import React from "react";
import CustomModal from "../../assets/components/ModalComonent";
import Classes from "./styles/style.module.css";

const StartMatchModal = ({ showModal, handleClose, start }) => {
  const modalContent = (
    <>
      <div className="w-100 text-center">
        <p className={Classes.dialogText}>
          اگه وارد چالش شدی، فقط ده دقیقه زمان داری و از دکمه برگشت نمیتونی
          استفاده کنی.
          <br /> آماده‌ای؟ 😃
        </p>
        <div className="d-flex justify-content-between px-2 mb-2">
          <button className={Classes.CustomButton} onClick={start}>
            شروع
          </button>
          <button className={Classes.CustomButton} onClick={handleClose}>
            بستن
          </button>
        </div>
      </div>
    </>
  );

  return (
    <CustomModal
      open={showModal}
      closeHandler={handleClose}
      inputDialog={true}
      dialogContent={modalContent}
    />
  );
};

export default StartMatchModal;
